const Mensitemss = [
  {
    category: "men",
    subcategory: "Undershirt",
    name: "Sous-vêtements amincissants de contrôle du ventre réglable",
    price: "16.99",
    raw_price: "39.97",
    currency: "USD",
    discount: "58",
    likes_count: "382",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "",
    variation_0_color: "Black",
    variation_1_color: "White",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/76/B1/f89df83f-9c38-4a28-aa8f-917ddb7985bf.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/76/B1/f89df83f-9c38-4a28-aa8f-917ddb7985bf.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/DA/78/e9986237-bbb7-4d23-bbff-4ced2243d767.jpeg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/DA/78/e9986237-bbb7-4d23-bbff-4ced2243d767.jpeg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/52/73/892835b1-4f02-4e35-a73c-0004fe3ff494.jpg",
    url: "https://fr.newchic.com/mens-shapewear-8149/p-1626609.html",
    id: "1626609",
    model: "SKUE30713",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemises à manches courtes à rayures",
    price: "17.99",
    raw_price: "35.98",
    currency: "USD",
    discount: "50",
    likes_count: "275",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black strip",
    variation_1_color: "Rayure bleue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/5E/BD/25215f7f-7d46-4be6-a895-04bbe4e23394.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5E/BD/25215f7f-7d46-4be6-a895-04bbe4e23394.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/1A/B9/a3cf3082-931e-41c4-8fee-8ea0815c5b08.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/1A/B9/a3cf3082-931e-41c4-8fee-8ea0815c5b08.jpg",
    url: "https://fr.newchic.com/shirts-12209/p-1696680.html",
    id: "1696680",
    model: "SKUF37566",
  },
  {
    category: "men",
    subcategory: "Henley Shirts",
    name: "Chemise Henley en lin respirant pour homme",
    price: "16.98",
    raw_price: "39.99",
    currency: "USD",
    discount: "58",
    likes_count: "3686",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DE/B2/f48684e2-845c-4102-87d1-60cdeb6c5daa.jpg",

    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C1/DC/96cf14d7-0cab-4c2c-86ff-19850b8ed213.jpg",
    url: "https://fr.newchic.com/henley-shirts-12211/p-1676437.html",
    id: "1676437",
    model: "SKUE55668",
  },
  {
    category: "men",
    subcategory: "Pyjama",
    name: "Pyjama confortable en coton et lin",
    price: "31.35",
    raw_price: "45.26",
    currency: "USD",
    discount: "31",
    likes_count: "140",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Grey",
    variation_1_color: "Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/28/AB/085b12e4-43c3-46f9-b3ec-100acacb56de.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/28/AB/085b12e4-43c3-46f9-b3ec-100acacb56de.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/DE/B2/f48684e2-845c-4102-87d1-60cdeb6c5daa.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DE/B2/f48684e2-845c-4102-87d1-60cdeb6c5daa.jpg",
    url: "https://fr.newchic.com/pajamas-sets-6150/p-1658681.html",
    id: "1658681",
    model: "SKUE87235",
  },
  {
    category: "men",
    subcategory: "Henley Shirts",
    name: "Chemise vintage en couleur pure à col montant",
    price: "20.99",
    raw_price: "38.99",
    currency: "USD",
    discount: "46",
    likes_count: "11521",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Vert foncé",
    variation_1_color: "kaki",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/AE/24/8e681346-64cb-432f-8ba1-caa4e8fdfe0c.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/AE/24/8e681346-64cb-432f-8ba1-caa4e8fdfe0c.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/86/CD/0873a7e6-eb58-403a-af4d-b7da37d10b2c.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/86/CD/0873a7e6-eb58-403a-af4d-b7da37d10b2c.jpg",
    image_url: "",
    url: "https://fr.newchic.com/henley-shirts-12211/p-1361733.html",
    id: "1361733",
    model: "SKUA44469",
  },
  {
    category: "men",
    subcategory: "T-Shirts",
    name: "T-shirt décontracté en coton uni avec poche poitrine",
    price: "9.99",
    raw_price: "25.99",
    currency: "USD",
    discount: "62",
    likes_count: "2627",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Navy",
    variation_1_color: "Wine Red",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C1/BA/93d5c0e2-ce44-4852-9a8a-02ce532e9d38.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C1/BA/93d5c0e2-ce44-4852-9a8a-02ce532e9d38.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/A1/7D/abba773c-0c24-48c6-83cd-8caacc2eff2f.jpeg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/A1/7D/abba773c-0c24-48c6-83cd-8caacc2eff2f.jpeg",
    image_url: "",
    url: "https://fr.newchic.com/t-shirts-12208/p-1650894.html",
    id: "1650894",
    model: "SKUE67015",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemises à poches multicolores",
    price: "16.99",
    raw_price: "33.94",
    currency: "USD",
    discount: "50",
    likes_count: "6570",
    is_new: "false",
    brand: "ChArmkpR",
    brand_url: "https://fr.newchic.com/charmkpr-brand-39.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Blue",
    variation_1_color: "Yellow",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/18/2E/fc4df957-5347-47a8-a918-2b70fe9d2e6a.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/18/2E/fc4df957-5347-47a8-a918-2b70fe9d2e6a.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/D2/43/ee83e3eb-b3c5-4f40-a77c-6e8300925fa6.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D2/43/ee83e3eb-b3c5-4f40-a77c-6e8300925fa6.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/ED/D5/8f68f3bb-f170-4b7e-966b-3ab681ce8277.jpg",
    url: "https://fr.newchic.com/charmkpr-shirts-12209/p-1644753.html",
    id: "1644753",
    model: "SKUE56372",
  },
  {
    category: "men",
    subcategory: "Pyjama",
    name: "Plus Pyjama design patchwork taille",
    price: "23.99",
    raw_price: "0",
    currency: "USD",
    discount: "0",
    likes_count: "101",
    is_new: "false",
    brand: "INCERUN",
    brand_url: "https://fr.newchic.com/incerun-brand-212.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Rose",
    variation_1_color: "Vin rouge",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/0D/DF/2ab83ec4-4e93-402a-8776-3d23b225822d.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0D/DF/2ab83ec4-4e93-402a-8776-3d23b225822d.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/D8/5F/19f3e6b2-6dcd-4f7d-ba07-6882871b9e36.jpeg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D8/5F/19f3e6b2-6dcd-4f7d-ba07-6882871b9e36.jpeg",
    url: "https://fr.newchic.com/incerun-pajamas-sets-6150/p-1679383.html",
    id: "1679383",
    model: "SKUE16676",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemises Imprimées Branches Vintage",
    price: "23.09",
    raw_price: "33.94",
    currency: "USD",
    discount: "32",
    likes_count: "3474",
    is_new: "false",
    brand: "ChArmkpR",
    brand_url: "https://fr.newchic.com/charmkpr-brand-39.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Khaki",
    variation_1_color: "Coffee",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6A/50/95caa407-bcff-420f-9a4a-bf3aa6a72615.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6A/50/95caa407-bcff-420f-9a4a-bf3aa6a72615.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/FA/3A/2704bafd-afdd-45b9-8479-dc72c05a7b20.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/FA/3A/2704bafd-afdd-45b9-8479-dc72c05a7b20.jpg",
    image_url: "",
    url: "https://fr.newchic.com/charmkpr-shirts-12209/p-1649599.html",
    id: "1649599",
    model: "SKUE54146",
  },
  {
    category: "men",
    subcategory: "T-Shirts",
    name: "T-shirts graphiques Astronaute et Terre",
    price: "9.99",
    raw_price: "29.99",
    currency: "USD",
    discount: "67",
    likes_count: "1447",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Grey",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/06/88/0fc06d4d-95bf-4f21-9e4f-3d6b803e49fb.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/06/88/0fc06d4d-95bf-4f21-9e4f-3d6b803e49fb.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/33/B3/8126309d-effc-45ea-a0b7-f12adaf69a14.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/33/B3/8126309d-effc-45ea-a0b7-f12adaf69a14.jpg",
    image_url: "",
    url: "https://fr.newchic.com/t-shirts-12208/p-1685394.html",
    id: "1685394",
    model: "SKUF32558",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemise à imprimé floral en porcelaine pour homme",
    price: "18.99",
    raw_price: "37.71",
    currency: "USD",
    discount: "50",
    likes_count: "8872",
    is_new: "false",
    brand: "ChArmkpR",
    brand_url: "https://fr.newchic.com/charmkpr-brand-39.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Noir",
    variation_1_color: "Bleu",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/25/4C/50f451e6-ca2b-46f6-a6c1-97171a27e857.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/25/4C/50f451e6-ca2b-46f6-a6c1-97171a27e857.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/63/63/a1b209ec-ab12-4bc0-94c6-f1d2d2865ff2.jpeg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/63/63/a1b209ec-ab12-4bc0-94c6-f1d2d2865ff2.jpeg",
    url: "https://fr.newchic.com/charmkpr-shirts-12209/p-1496404.html",
    id: "1496404",
    model: "SKUC48987",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemises 100% coton imprimées pour hommes",
    price: "20.99",
    raw_price: "37.71",
    currency: "USD",
    discount: "44",
    likes_count: "9211",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "vert",
    variation_1_color: "Bleu",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/71/11/3bd1c863-3ba9-4cde-ae3d-fcbc6b0a0e54.JPG",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/71/11/3bd1c863-3ba9-4cde-ae3d-fcbc6b0a0e54.JPG",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/35/95/023a0648-3b53-495b-8643-4856fd69aebb.JPG",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/35/95/023a0648-3b53-495b-8643-4856fd69aebb.JPG",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/97/8F/2d9d8806-d805-4cd9-9972-ecb4997a7ad9.JPG",
    url: "https://fr.newchic.com/shirts-12209/p-1527110.html",
    id: "1527110",
    model: "SKUC66899",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemises unie Striola Chest Pocket",
    price: "16.49",
    raw_price: "28.28",
    currency: "USD",
    discount: "42",
    likes_count: "5267",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Blue",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/E2/6B/c3b5dc3b-5d9f-4e2f-8d36-d2cecb4c3acf.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E2/6B/c3b5dc3b-5d9f-4e2f-8d36-d2cecb4c3acf.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F4/B9/2abe8fb7-84c4-457f-b44b-e1ebc4232906.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F4/B9/2abe8fb7-84c4-457f-b44b-e1ebc4232906.jpg",
    image_url: "",
    url: "https://fr.newchic.com/shirts-12209/p-1646547.html",
    id: "1646547",
    model: "SKUE37685",
  },
  {
    category: "men",
    subcategory: "T-Shirts",
    name: "T-shirt 100% coton à col en V de couleur unie",
    price: "9.99",
    raw_price: "28.28",
    currency: "USD",
    discount: "65",
    likes_count: "788",
    is_new: "false",
    brand: "ChArmkpR",
    brand_url: "https://fr.newchic.com/charmkpr-brand-39.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Sky Blue",
    variation_1_color: "White",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/51/E1/c4c0ec98-0b8e-4338-a0b9-d70e4b2fceb5.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/51/E1/c4c0ec98-0b8e-4338-a0b9-d70e4b2fceb5.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/38/CE/266c4322-47eb-428f-a072-db8208703c3e.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/38/CE/266c4322-47eb-428f-a072-db8208703c3e.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0E/1B/dcc314f9-7455-48cc-ae97-76ce052ecb3d.jpg",
    url: "https://fr.newchic.com/charmkpr-t-shirts-12208/p-1689337.html",
    id: "1689337",
    model: "SKUF22170",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemise à col montant en lin respirant",
    price: "16.99",
    raw_price: "33.99",
    currency: "USD",
    discount: "50",
    likes_count: "1040",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "blanc",
    variation_1_color: "gris",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/C3/E9/7c9dc43d-a0fd-4935-9b71-33e8c294a80b.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/C3/E9/7c9dc43d-a0fd-4935-9b71-33e8c294a80b.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/BE/31/bb24c4ec-0793-43f0-b0d5-2c033c0da21f.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BE/31/bb24c4ec-0793-43f0-b0d5-2c033c0da21f.jpg",
    image_url: "",
    url: "https://fr.newchic.com/shirts-12209/p-1687607.html",
    id: "1687607",
    model: "SKUF04403",
  },
  {
    category: "men",
    subcategory: "Pyjama",
    name: "Ensembles de chemises en coton et lin",
    price: "31.99",
    raw_price: "60.35",
    currency: "USD",
    discount: "47",
    likes_count: "15",
    is_new: "true",
    brand: "ChArmkpR",
    brand_url: "https://fr.newchic.com/charmkpr-brand-39.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "",
    variation_1_color: "",
    variation_0_thumbnail: "",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9F/BA/65e09384-af2c-44c5-ab9e-97853bc56324.jpg",

    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/37/07/8d7652a6-3603-4502-86f5-49965a6bd014.jpg",
    url: "https://fr.newchic.com/charmkpr-pajamas-sets-6150/p-1715461.html",
    id: "1715461",
    model: "SKUF80490",
  },
  {
    category: "men",
    subcategory: "Henley Shirts",
    name: "Chemise Henley Décontractée Solide en Lin de Coton Vintage",
    price: "20.99",
    raw_price: "33.94",
    currency: "USD",
    discount: "38",
    likes_count: "3440",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Bleu",
    variation_1_color: "Jaune",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/9F/BA/65e09384-af2c-44c5-ab9e-97853bc56324.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9F/BA/65e09384-af2c-44c5-ab9e-97853bc56324.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/97/F5/6c9f31c9-17fc-4184-b8f4-5cb9d7749eff.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/97/F5/6c9f31c9-17fc-4184-b8f4-5cb9d7749eff.jpg",
    image_url: "",
    url: "https://fr.newchic.com/henley-shirts-12211/p-1439022.html",
    id: "1439022",
    model: "SKUB55545",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Coton Colorful Chemise à rayures",
    price: "18.89",
    raw_price: "35.99",
    currency: "USD",
    discount: "48",
    likes_count: "3566",
    is_new: "false",
    brand: "ChArmkpR",
    brand_url: "https://fr.newchic.com/charmkpr-brand-39.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Green",
    variation_1_color: "Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/6D/59/4b211a09-05d8-4db7-bb8e-104744ee113b.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/6D/59/4b211a09-05d8-4db7-bb8e-104744ee113b.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/11/09/a2d5d4bd-fe49-425c-aa04-d6acbc7cfea5.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/11/09/a2d5d4bd-fe49-425c-aa04-d6acbc7cfea5.jpg",
    image_url: "",
    url: "https://fr.newchic.com/charmkpr-shirts-12209/p-1662372.html",
    id: "1662372",
    model: "SKUE94088",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemises à manches courtes imprimées à l'huile florale vintage",
    price: "19.79",
    raw_price: "28.28",
    currency: "USD",
    discount: "30",
    likes_count: "3542",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Yellow",
    variation_1_color: "Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/52/0F/dfcb1f89-19a5-4e2a-9f74-9b979535819b.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/52/0F/dfcb1f89-19a5-4e2a-9f74-9b979535819b.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/93/DC/99106ef3-534c-4b81-8865-28c288565d72.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/93/DC/99106ef3-534c-4b81-8865-28c288565d72.jpg",
    image_url: "",
    url: "https://fr.newchic.com/shirts-12209/p-1653022.html",
    id: "1653022",
    model: "SKUE55334",
  },

  {
    category: "men",
    subcategory: "T-Shirts",
    name: "Mens Sample Cartoon Cat Graphic Casual Cotton Short Sleeve T-Shirt",
    price: "9.99",
    raw_price: "28.99",
    currency: "USD",
    discount: "66",
    likes_count: "1799",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "vert",
    variation_1_color: "Bleu clair",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/EC/B4/2fd65b9b-9db6-4bb4-a7c1-650faf254fbf.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/EC/B4/2fd65b9b-9db6-4bb4-a7c1-650faf254fbf.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/DC/FC/5a85a380-b6e4-4c73-b5f1-e34e041d304d.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/DC/FC/5a85a380-b6e4-4c73-b5f1-e34e041d304d.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/06/84/167f5d6d-a1b7-4353-b050-c9b5c2f64a4c.jpg",
    url: "https://fr.newchic.com/t-shirts-12208/p-1677892.html",
    id: "1677892",
    model: "SKUF20434",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemise patchwork de couleur contrastée",
    price: "17.99",
    raw_price: "33.94",
    currency: "USD",
    discount: "47",
    likes_count: "2502",
    is_new: "false",
    brand: "ChArmkpR",
    brand_url: "https://fr.newchic.com/charmkpr-brand-39.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/00/E1/0b90ea72-8abd-4c60-a278-79b2589fe65a.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/00/E1/0b90ea72-8abd-4c60-a278-79b2589fe65a.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/0C/85/f0291ea0-bd26-45bd-b323-8d31bdef1599.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/0C/85/f0291ea0-bd26-45bd-b323-8d31bdef1599.jpg",
    image_url: "",
    url: "https://fr.newchic.com/charmkpr-shirts-12209/p-1680786.html",
    id: "1680786",
    model: "SKUF20181",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemises imprimées de graffitis de dessin animé pour hommes",
    price: "18.99",
    raw_price: "33.94",
    currency: "USD",
    discount: "44",
    likes_count: "8248",
    is_new: "false",
    brand: "ChArmkpR",
    brand_url: "https://fr.newchic.com/charmkpr-brand-39.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Blue",
    variation_1_color: "Lake Blue",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/23/C7/f451f9ab-6609-47fb-80a8-106f142382ba.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/23/C7/f451f9ab-6609-47fb-80a8-106f142382ba.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/23/18/63a6666c-f262-4a11-b5d5-78ae991b7003.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/23/18/63a6666c-f262-4a11-b5d5-78ae991b7003.jpg",
    url: "https://fr.newchic.com/charmkpr-shirts-12209/p-1541922.html",
    id: "1541922",
    model: "SKUD14678",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemise patchwork à rayures plantes et feuilles",
    price: "17.99",
    raw_price: "33.94",
    currency: "USD",
    discount: "47",
    likes_count: "2521",
    is_new: "false",
    brand: "ChArmkpR",
    brand_url: "https://fr.newchic.com/charmkpr-brand-39.html",
    codCountry: "",
    variation_0_color: "Jaune",
    variation_1_color: "Orange",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/5D/CC/640003cb-be55-4168-97eb-e1c7c887403c.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5D/CC/640003cb-be55-4168-97eb-e1c7c887403c.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/1D/26/5f1daba2-3043-42ed-a930-272d8fca89bb.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/1D/26/5f1daba2-3043-42ed-a930-272d8fca89bb.jpg",
    image_url: "",
    url: "https://fr.newchic.com/charmkpr-shirts-12209/p-1677991.html",
    id: "1677991",
    model: "SKUF08173",
  },
  {
    category: "men",
    subcategory: "Pantalons",
    name: "Pantalon bouffant ample en 100% coton",
    price: "29.39",
    raw_price: "50.29",
    currency: "USD",
    discount: "42",
    likes_count: "6481",
    is_new: "false",
    brand: "ChArmkpR",
    brand_url: "https://fr.newchic.com/charmkpr-brand-39.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Vert foncé",
    variation_1_color: "Noir",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/55/60/4da21dba-c700-4337-bd80-640da97dccb5.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/55/60/4da21dba-c700-4337-bd80-640da97dccb5.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/3F/6B/e6a3d9c8-7327-4392-9660-4d10e952d7b0.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/3F/6B/e6a3d9c8-7327-4392-9660-4d10e952d7b0.jpg",
    image_url: "",
    url: "https://fr.newchic.com/charmkpr-pants-4975/p-1285524.html",
    id: "1285524",
    model: "SKU924208",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemise patchwork à rayures de paysage",
    price: "17.99",
    raw_price: "33.94",
    currency: "USD",
    discount: "47",
    likes_count: "1969",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Orange",
    variation_1_color: "Bleu",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/E1/A3/b1322050-7060-4a9a-a3bd-2330fdbc26ff.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/E1/A3/b1322050-7060-4a9a-a3bd-2330fdbc26ff.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/5D/03/709141a4-288e-4311-9f79-6eddaa342460.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5D/03/709141a4-288e-4311-9f79-6eddaa342460.jpg",
    image_url: "",
    url: "https://fr.newchic.com/shirts-12209/p-1677988.html",
    id: "1677988",
    model: "SKUF08187",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemise unie respirante légère",
    price: "15.74",
    raw_price: "28.28",
    currency: "USD",
    discount: "44",
    likes_count: "2692",
    is_new: "false",
    brand: "ChArmkpR",
    brand_url: "https://fr.newchic.com/charmkpr-brand-39.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Yellow",
    variation_1_color: "Khaki",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/D4/F6/cb270942-4471-4ac1-b19a-f6ed6a6cf1ae.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D4/F6/cb270942-4471-4ac1-b19a-f6ed6a6cf1ae.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/7F/CE/59124483-7e09-4eb6-aea7-1231362278e4.jpeg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/7F/CE/59124483-7e09-4eb6-aea7-1231362278e4.jpeg",
    image_url: "",
    url: "https://fr.newchic.com/charmkpr-shirts-12209/p-1662784.html",
    id: "1662784",
    model: "SKUE54946",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemise à col rabattu imprimé peinture chinoise",
    price: "38.84",
    raw_price: "59.99",
    currency: "USD",
    discount: "35",
    likes_count: "3036",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "White",
    variation_1_color: "Black",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F2/8C/fd7a77a4-e255-41eb-8daa-4981fb4b24d9.JPG",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F2/8C/fd7a77a4-e255-41eb-8daa-4981fb4b24d9.JPG",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/9C/D5/ac7195e5-f79d-4541-a12c-7d2ed16a520f.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9C/D5/ac7195e5-f79d-4541-a12c-7d2ed16a520f.jpg",
    image_url: "",
    url: "https://fr.newchic.com/shirts-12209/p-1528008.html",
    id: "1528008",
    model: "SKUC62470",
  },
  {
    category: "men",
    subcategory: "Pyjama",
    name: "Vêtement d'intérieur léger en lin de coton uni",
    price: "27.99",
    raw_price: "52.81",
    currency: "USD",
    discount: "47",
    likes_count: "195",
    is_new: "false",
    brand: "ChArmkpR",
    brand_url: "https://fr.newchic.com/charmkpr-brand-39.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Marine",
    variation_1_color: "blanc",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/F7/8C/e7ded727-56f6-4ff6-8cf3-7d831797b602.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/F7/8C/e7ded727-56f6-4ff6-8cf3-7d831797b602.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/5C/E8/aa0c9ab4-006f-4af5-821b-bf90015cfeb9.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/5C/E8/aa0c9ab4-006f-4af5-821b-bf90015cfeb9.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9F/14/5df84b9c-90a6-4259-bc92-0b323930f4f6.jpg",
    url: "https://fr.newchic.com/charmkpr-pajamas-sets-6150/p-1711299.html",
    id: "1711299",
    model: "SKUF73430",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemises rayées Classic pour hommes ",
    price: "19.79",
    raw_price: "33.94",
    currency: "USD",
    discount: "42",
    likes_count: "2238",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Red",
    variation_1_color: "Khaki",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/52/00/f39cd978-bb22-45db-b384-83cfbb193c6e.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/52/00/f39cd978-bb22-45db-b384-83cfbb193c6e.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/08/AA/6f0669cf-67b5-45be-a698-0dedc6bd46c8.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/08/AA/6f0669cf-67b5-45be-a698-0dedc6bd46c8.jpg",
    url: "https://fr.newchic.com/shirts-12209/p-1658562.html",
    id: "1658562",
    model: "SKUE72102",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemises lâches à manches courtes style ethnique",
    price: "20.99",
    raw_price: "42.99",
    currency: "USD",
    discount: "51",
    likes_count: "4623",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "As Picture",
    variation_1_color: "",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/97/98/b76a13e1-cf26-4351-b90e-49140c19fc8f.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/97/98/b76a13e1-cf26-4351-b90e-49140c19fc8f.jpg",
    variation_1_thumbnail: "",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/08/AA/6f0669cf-67b5-45be-a698-0dedc6bd46c8.jpg",

    url: "https://fr.newchic.com/shirts-12209/p-1537191.html",
    id: "1537191",
    model: "SKUC73976",
  },
  {
    category: "men",
    subcategory: "Shirts",
    name: "Chemise d'impression dégradé de coton ",
    price: "25.19",
    raw_price: "37.72",
    currency: "USD",
    discount: "33",
    likes_count: "2188",
    is_new: "false",
    brand: "INCERUN",
    brand_url: "https://fr.newchic.com/incerun-brand-212.html",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Orange",
    variation_1_color: "Bleu",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/7A/84/7a7a6de0-a466-4bea-9e27-363d331b81cd.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/7A/84/7a7a6de0-a466-4bea-9e27-363d331b81cd.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/ser1/newchic/images/84/AF/5120d90f-9cc9-4b19-a189-c28c41357af1.jpg",
    variation_1_image: "",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/84/AF/5120d90f-9cc9-4b19-a189-c28c41357af1.jpg",
    url: "https://fr.newchic.com/incerun-shirts-12209/p-1639578.html",
    id: "1639578",
    model: "SKUC92040",
  },
  {
    category: "men",
    subcategory: "T-Shirts",
    name: "T-shirt décontracté à col rond en coton et lin 8 couleurs",
    price: "14.99",
    raw_price: "28.28",
    currency: "USD",
    discount: "47",
    likes_count: "1979",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "White",
    variation_1_color: "Gray",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/88/C4/861979e1-07b5-41d7-adb5-8e7bbe46545c.jpeg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/88/C4/861979e1-07b5-41d7-adb5-8e7bbe46545c.jpeg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/9D/44/3d7d5229-bc0b-4587-a6c8-7e47992c4dcb.jpeg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/9D/44/3d7d5229-bc0b-4587-a6c8-7e47992c4dcb.jpeg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/EC/25/49097abd-7b50-4cda-9604-c98b8eac4664.jpeg",
    url: "https://fr.newchic.com/t-shirts-12208/p-1654823.html",
    id: "1654823",
    model: "SKUE67579",
  },
  {
    category: "men",
    subcategory: "Boxers & Slips de bain",
    name: "Tampon en éponge coupe 3D du pénis",
    price: "8.95",
    raw_price: "9.8",
    currency: "USD",
    discount: "9",
    likes_count: "584",
    is_new: "false",
    brand: "",
    brand_url: "",
    codCountry: "ID,MY,PH,SG,TH,VN",
    variation_0_color: "Black",
    variation_1_color: "White",
    variation_0_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/D6/B1/4a27a449-7906-46cc-9c8d-248c6c589853.jpg",
    variation_0_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/D6/B1/4a27a449-7906-46cc-9c8d-248c6c589853.jpg",
    variation_1_thumbnail:
      "https://imgaz1.chiccdn.com/thumb/list_grid/oaupload/newchic/images/BF/0F/9d2ac82b-d555-4010-a77f-9d4685ecd028.jpg",
    variation_1_image:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/newchic/images/BF/0F/9d2ac82b-d555-4010-a77f-9d4685ecd028.jpg",
    image_url:
      "https://imgaz1.chiccdn.com/thumb/view/oaupload/ser1/newchic/images/30/8E/fb3d0228-aa53-4e8a-b5c1-7228f02d6d25.jpg",
    url: "https://fr.newchic.com/mens-swimwear-6382/p-1533766.html",
    id: "1533766",
    model: "SKUC96316",
  },
];
export default Mensitemss;
